// @ts-nocheck

import {Component, CUSTOM_ELEMENTS_SCHEMA, OnInit} from '@angular/core';
import { AuthService } from './modules/services/auth-service/auth.service';
import { Observable, Subscription } from 'rxjs';
import { filter, share } from 'rxjs/operators';
import { UserLanguageService } from './modules/services/user-language-service/user-language.service';
import { AdminLanguageService } from './modules/services/admin-language-service/admin-language.service';
import { Administrator } from './models/administrator.model';
import { AdminAuthService } from './modules/services/admin-auth-service/admin-auth.service';
import { LocalStorageService } from './modules/services/localStorage-service/local-storage.service';
import { NavigationEnd, Router } from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import { ChatbotComponent } from './modules/chatbot/chatbot.component';
import {ChatbotModalComponent} from './modules/chatbot/chatbot-modal/chatbot-modal.component';
import { RedirectService } from './services/redirect.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {

  lang$: Observable<String>;
  labels$;
  labelsSub: Subscription;
  labels: any;
  adminLang$: Observable<String>;
  adminLabels$;
  title = 'frontend';
routerSubscription: Subscription
  isRouteChatbot = false;
  constructor(public redirectService: RedirectService, private router: Router, private localStorageService: LocalStorageService, private authService: AuthService, private adminAuthService: AdminAuthService, private languageService: UserLanguageService, private adminLanguageService: AdminLanguageService,
              private modal: MatDialog) { }

  ngOnInit(): void {
    console.log('app component refreshed')
    this.lang$ = this.languageService.getLanguage().pipe(share());
    this.labels$ = this.languageService.getLabels().pipe(share());

    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
    this.adminLang$ = this.adminLanguageService.getLanguage().pipe(share());
    this.adminLabels$ = this.adminLanguageService.getLabels().pipe(share());
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    )
      .subscribe(() => {
        if(document.querySelector('mat-drawer-content') != null) document.querySelector('mat-drawer-content').scrollTop = 0;
        this.isRouteChatbot = this.router.url.includes('chatbot') || this.router.url.includes('admin') || this.router.url.includes('test');
      });
    this.redirectService.init();
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  openAiModal() {
      this.modal.open(ChatbotModalComponent, {
        width: "500px",
        height: "600px",
      })
  }


}
